// extracted by mini-css-extract-plugin
module.exports = {"SubredditSkeleton":"Subreddit_SubredditSkeleton__5tUez"};